export async function APICall(
  apiUrl: any,
  methodType: any,
  inputParam: any,
  enableEncryption: boolean = true
) {
  if (enableEncryption) {
    try {
      let response = await fetch(apiUrl, {
        method: methodType,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
        body: JSON.stringify(inputParam),
      });

      const apiRes = await response.json();

      return apiRes;
    } catch (error) {
      return JSON.stringify(error);
    }
  }
}
